import { z } from 'zod'

/// https://developers.google.com/maps/documentation/places/web-service/details#Place

export const LatLngLiteralZod = z.object({
  lat: z.number(),
  lng: z.number(),
})

export const GooglePlaceDetailsZod = z.object({
  place_id: z.string(),
  formatted_address: z.string(),
  name: z.string().optional(),
  types: z.string().array().optional(),
  address_components: z.array(
    z.object({
      long_name: z.string(),
      short_name: z.string(),
      types: z.string().array(),
    })
  ),
  geometry: z.object({
    location: LatLngLiteralZod,
  }),
})

export type GooglePlaceDetails = z.infer<typeof GooglePlaceDetailsZod>
